import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import MyJobsPage from '@/features/home/my-jobs';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import { myJobsSearchSchema } from '@/features/home/my-jobs/my-jobs-search.schema';

export const Route = createFileRoute('/vagas/')({
  validateSearch: myJobsSearchSchema,
  component: () => (
    <HomeGate>
      <MyJobsPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
